import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFiftySevenPreLogin',
    name: 'IFPageOneHFiftySevenPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFiftySevenLogin' ||
        from.path === '/IFPageOneHFiftySevenLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFiftySevenLogin',
    name: 'pageOneHFiftySevenLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/login.vue'),
  },
  {
    path: '/IFPageOneHFiftySevenLoginLoading',
    name: 'pageOneHFiftySevenLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFiftySevenLeaveInfo',
    name: 'pageOneHFiftySevenLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFiftySevenResult',
    name: 'pageOneHFiftySevenResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/result.vue'),
  },
  {
    path: '/IFPageOneHFiftySevenLoading',
    name: 'pageOneHFiftySevenLoading',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFiftySevenLoginSecond',
    name: 'pageOneHFiftySevenLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftySevenOnline',
    name: 'pageOneHFiftySevenOnline',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFiftySevenLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFiftySevenGuide',
    name: 'pageOneHFiftySevenLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
      path: '/IFPageOneHFiftySevenCar',
      name: 'pageOneHFiftySevenCar',
      component: () => import('@/pages/pageListAll/pageOneHFiftySeven/car.vue'),
      meta: {
        title: '补充留资',
      },
    },
    {
      path: '/IFPageOneHFiftySevenCarDetails',
      name: 'pageOneHFiftySevenCarDetails',
      component: () => import('@/pages/pageListAll/pageOneHFiftySeven/carDetails.vue'),
      meta: {
        title: '申请结果',
      },
    },*/
  {
    path: '/IFPageOneHFiftySevenBlank',
    name: 'pageOneHFiftySevenBlank',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftySevenOnlineTab',
    name: 'pageOneHFiftySevenOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftySevenOnlineAd',
    name: 'pageOneHFiftySevenOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFiftySeven/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
